<template>
	<div v-loading="loading">
		<h2 style="margin-bottom: 30px;">会员权益详情</h2>
		<div class="father">
			<div class="left">
				<el-form label-width="150px" label-position="left" style="height: auto;">
					<el-form-item label="名称">
						<el-input v-model="sendData.name" style="width: 300px;"></el-input>
					</el-form-item>
					<el-form-item label="是否能单独购买">
						<el-radio-group v-model="sendData.onlyBuy">
							<el-radio label="1">是</el-radio>
							<el-radio label="0">否</el-radio>
						</el-radio-group>
					</el-form-item>
					<el-form-item label="选择券或券包">
						<el-radio-group v-model="sendData.coupon">
							<el-radio key="0" label="0" value="0">券</el-radio>
							<el-radio key="1" label="1" value="1">券包</el-radio>
						</el-radio-group>
					</el-form-item>
					<el-form-item v-if="sendData.coupon == 0" label="添加券">
						<el-tag>券id：{{sendData.couponId}}</el-tag>
						<el-button type="text" size="small" @click="dialog_quan=true"
							style="color:#999; border:2px dashed; width:100px;margin-left: 10px;">
							<i class="el-icon-plus"></i>选择券
						</el-button>
					</el-form-item>
					<el-form-item v-if="sendData.coupon == 1" label="添加券包">
						<el-tag>券包id：{{sendData.couponId}}</el-tag>
						<el-button type="text" @click="dialog_package=true"
							style="color:#999; border:2px dashed; width:100px;margin-left: 10px;">
							<i class="el-icon-plus"></i>选择券包
						</el-button>
					</el-form-item>
					<el-form-item label="会员购买价格">
						<el-input v-model="sendData.priceMember" style="width: 300px;">
							<template slot-scope="scope">
								{{(sendData.priceMember /1).toFixed(2)}}
							</template>
						</el-input>
					</el-form-item>
					<el-form-item label="非会员购买价格">
						<el-input :disabled="sendData.onlyBuy == 0" v-model="sendData.priceNormal"
							style="width: 300px;"></el-input>
					</el-form-item>
					<el-form-item label="成本">
						<el-input :disabled="sendData.onlyBuy == 0" v-model="sendData.priceNormal"
							style="width: 300px;"></el-input>
					</el-form-item>
					<el-form-item label="业绩">
						<el-input v-model="sendData.commission" style="width: 300px;"></el-input>
					</el-form-item>
					<el-form-item label="赠送会员卡">
						<el-select style="width: 150px;" size="small" v-model="sendData.memberId">
							<el-option v-for="item in memberCard" :key="item.id" :label="item.title"
								:value="item.id"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="跳转方式">
						<el-select style="width: 150px;" size="small" v-model="sendData.jumpMode">
							<el-option v-for="item in jumpMode" :key="item.value" :label="item.label"
								:value="item.value"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="APPID(非必填)">
						<el-input v-model="sendData.appId" style="width: 300px;"></el-input>
					</el-form-item>
					<el-form-item label="跳转地址">
						<el-input v-model="sendData.url" style="width: 300px;"></el-input>
					</el-form-item>
					<el-form-item label="套餐类型">
						<el-select style="width: 150px;" size="small" v-model="sendData.combine">
							<el-option v-for="item in combine" :key="item.value" :label="item.label"
								:value="item.value"></el-option>
						</el-select>
					</el-form-item>
					<!-- 				<el-form-item label="产品加购">
					<div class="flex">
						加<el-input size="small" style="width: 100px;"></el-input>元，获得
						<span></span>
					</div>
					<div style="font-size: 30px;">
						<i @click="addTypeMethod()" class="el-icon-circle-plus-outline" size="small"></i>
					</div>
				</el-form-item> -->
					<el-form-item label="可见状态">
						<el-select style="width: 150px;" size="small" v-model="sendData.member">
							<el-option v-for="item in member" :key="item.value" :label="item.label"
								:value="item.value"></el-option>
						</el-select>
					</el-form-item>
					<!-- 				<el-form-item label="是否填写地址">
					<el-radio v-model="sendData.address" :label="false">不需要</el-radio>
					<el-radio v-model="sendData.address" :label="true">需要</el-radio>
				</el-form-item> -->
					<el-form-item label="是否显示">
						<el-switch v-model="sendData.hidden" active-text="显示" inactive-text="隐藏">
						</el-switch>
					</el-form-item>
					<el-form-item label="显示顺序">
						<el-input v-model="sendData.orderBy" style="width: 300px;"></el-input>
					</el-form-item>
					<el-form-item label="规则" style="height: 350px;">
						<quill-editor v-model="sendData.content" ref="myQuillEditor"
							style="height: 200px; width: 500px;">
						</quill-editor>
					</el-form-item>
					<el-form-item label="规则" style="height: 100px;">
						<el-input type="textarea" v-model="sendData.remark" style="width: 500px;"></el-input>
					</el-form-item>
					<el-form-item>
						<router-link to="/appletSettings">
							<el-button>取消</el-button>
						</router-link>
						<el-button @click="save()" type="primary" style="margin-left: 20px;">保存</el-button>
					</el-form-item>
				</el-form>
			</div>
			<div class="right">
				<el-form>
					<el-form-item label="上传图片">
						<div>
							<div>
								<upload v-model="sendData.imageSmall"  class="el-tabs-pane-upload"  ref="sss"
									style="width: 300px; height: 150px; margin-top: 10px; margin-left: 30px;" />
								<p style="font-size: 14px;color: #808080;margin-top: 30px; margin-left: 30px;">点击上传小图片
								</p>
							</div>
							<div>
								<upload v-model="sendData.imageBig2"  class="el-tabs-pane-upload"  ref="sss"
									style="width: 300px; height: 150px; margin-left: 30px;" />
								<p style="font-size: 14px;color: #808080; margin-left: 30px;">点击上传详情页图片2</p>
							</div>
							<div>
								<upload v-model="sendData.imageBig"  class="el-tabs-pane-upload"  ref="sss"
									style="width: 300px; height: 300px;; margin-left: 30px;" />
								<p style="font-size: 14px;color: #808080; margin-left: 30px;">点击上传详情页图片</p>
							</div>
						</div>
					</el-form-item>
				</el-form>
			</div>
		</div>
		<el-dialog :visible.sync="dialog_quan" width="60%">
			<div class="title" style="margin-top:-10px;">
				<div class="blue"></div>
				<div style="flex: 1; font-size: 18px;">选择优惠券</div>
				<span style="float: right; margin-bottom: 10px;">
					<el-button @click="dialog_quan = false">取 消</el-button>
					<el-button type="primary" @click="dialog_quan = false">确 定</el-button>
				</span>
			</div>
			<div>
				<el-table :cell-style="{'text-align':'center'}"
					:header-cell-style="{background:'#F2F2F4','text-align':'center'}" ref="multipleTable"
					:data="couponList" tooltip-effect="dark" style="width: 100%">
					<el-table-column label="券ID">
						<template scope="scope">
							<el-radio :label="scope.row.id" v-model="sendData.couponId"></el-radio>
						</template>
					</el-table-column>
					<el-table-column align="center" prop="title" label="名称"></el-table-column>
					<el-table-column prop="couponType" label="类型"></el-table-column>
					<el-table-column prop="storeNames" label="适用范围"></el-table-column>
					<el-table-column prop="termOfValidity" label="有效期"></el-table-column>
					<el-table-column prop="getNumScaleTotalNum" label="已领取/优惠券总量"></el-table-column>
					<el-table-column prop="useNum" label="已使用"></el-table-column>
				</el-table>
				<div class="pagescg">
					<el-pagination @size-change="handleSizeChange01" @current-change="handleCurrentChange01"
						:current-page="filter.page" :page-sizes="[10, 20, 30, 50]" :page-size="10"
						layout="total, sizes, prev, pager, next, jumper" :total="filter.total">
					</el-pagination>
				</div>
			</div>
		</el-dialog>
		<el-dialog :visible.sync="dialog_package" width="60%">
			<div class="title" style="margin-top:-10px;">
				<div class="blue"></div>
				<div style="flex: 1; font-size: 18px;">选择券包</div>
				<span style="float: right; margin-bottom: 10px;">
					<el-button @click="dialog_package = false">取 消</el-button>
					<el-button type="primary" @click="dialog_package = false">确 定</el-button>
				</span>
			</div>
			<div>
				<el-table :cell-style="{'text-align':'center'}"
					:header-cell-style="{background:'#F2F2F4','text-align':'center'}" ref="multipleTable"
					:data="couponPackageList" tooltip-effect="dark" style="width: 100%">
					<el-table-column label="券包ID">
						<template scope="scope">
							<el-radio :label="scope.row.id" v-model="sendData.couponId"></el-radio>
						</template>
					</el-table-column>
					<el-table-column prop="name" align="center" label="名称"></el-table-column>
					<el-table-column prop="termOfValidity" label="有效期"></el-table-column>
				</el-table>
				<div class="pagescg">
					<el-pagination @size-change="handleSizeChange02" @current-change="handleCurrentChange02"
						:current-page="filter2.page" :page-sizes="[10, 20, 30, 50]" :page-size="10"
						layout="total, sizes, prev, pager, next, jumper" :total="filter2.total">
					</el-pagination>
				</div>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import upload from "../../compents/upload/upload";
	export default {
		components: {
			upload
		},
		data() {
			return {
				loading: false,
				filter: {
					pageNum: 1,
					pageSize: 10,
					total: 100
				},
				filter2: {
					pageNum: 1,
					pageSize: 20,
					total: 100
				},
				dialog_quan: false,
				dialog_package: false,
				onlyBuy: '',
				coupon: '',
				jumpMode1: '',
				jumpMode: [{
					value: "3",
					label: '填写收货地址'
				}, {
					value: "2",
					label: '填写手机号'
				}, {
					value: "1",
					label: '外部链接'
				}, {
					value: "0",
					label: '没有跳转'
				}],
				sendData: {
					name: '',
					onlyBuy: '',
					coupon: [],
					couponId: '',
					priceMember: '',
					priceNormal: '',
					commission: '',
					imageBig: '',
					imageBig2: '',
					imageSmall: '',
					jumpMode: [],
					url: '',
					hidden: true,
					orderBy: '',
					content: '',
					combine: 'A',
				},
				member: [{
					value: 0,
					label: '全部可见'
				}, {
					value: 1,
					label: '仅会员(老用户)可见'
				}, {
					value: 2,
					label: '仅非会员(新用户)可见'
				}, ],
				combine: [{
					value: 'A',
					label: 'A(常规)'
				}, {
					value: 'B',
					label: 'B(合作店)'
				}, ],
				couponList: [],
				couponPackageList: [],
				memberCard: [],
				addType: ''
			}
		},
		mounted() {
			this.getCoupon();
			this.getCouponPackage();
			if (this.$route.query.id != null) {
				this.getDetail();
			}
			this.getMemberCard()
		},
		methods: {
			getCoupon() {
				this.$http.get("dCoupon/list" + "?pageNum=" + this.filter.pageNum + "&pageSize=" + this.filter.pageSize)
					.then(res => {
						this.couponList = res.body.data;
						this.filter.total = res.body.total;
					})
			},
			getCouponPackage() {
				this.$http.post("couponPackage/findDCouponPackage", JSON.stringify(this.filter2)).then(res => {
					this.couponPackageList = res.body.data;
					this.filter2.total = res.body.total;
				})
			},
			getDetail() {
				this.lodaing = true
				this.$http.get("member/detail" + "?id=" + this.$route.query.id).then(res => {
					if (res.body.code == 200) {
						this.lodaing = false
						var a = res.body.data;
						this.sendData = a;
						this.sendData.name = a.name;
						this.sendData.onlyBuy = a.onlyBuy.toString();
						this.sendData.coupon = a.coupon.toString();
						this.sendData.couponId = a.couponId;
						this.sendData.priceMember = (a.priceMember / 100).toFixed(2);
						this.sendData.priceNormal = (a.priceNormal / 100).toFixed(2);
						this.sendData.commission = (a.commission / 100).toFixed(2);
						this.sendData.imageBig = a.imageBig;
						this.sendData.imageBig2 = a.imageBig2;
						this.sendData.imageSmall = a.imageSmall;
						this.sendData.jumpMode = a.jumpMode;
						this.sendData.url = a.url;
						this.sendData.orderBy = a.orderBy;
						this.sendData.content = a.content;
						this.sendData.memberId = a.memberId;
						this.sendData.combine = a.combine;
						this.sendData.member = a.member;
						this.sendData.appId = a.appId;
						this.sendData.address = a.address
						if (a.hidden == 1) {
							this.sendData.hidden = false
						} else {
							this.sendData.hidden = true
						}
					}
				})
			},
			save() {
				let t = 1; //隐藏为1
				if (this.sendData.hidden) {
					t = 0 //显示为0
				}
				let a = {
					id: this.$route.query.id,
					name: this.sendData.name,
					onlyBuy: this.sendData.onlyBuy,
					coupon: this.sendData.coupon.toString(),
					couponId: this.sendData.couponId,
					priceMember: this.sendData.priceMember * 100,
					priceNormal: this.sendData.priceNormal * 100,
					commission: this.sendData.commission * 100,
					imageBig: this.sendData.imageBig,
					imageBig2: this.sendData.imageBig2,
					imageSmall: this.sendData.imageSmall,
					jumpMode: this.sendData.jumpMode,
					url: this.sendData.url,
					orderBy: this.sendData.orderBy,
					content: this.sendData.content,
					hidden: t,
					combine: this.sendData.combine,
					member: this.sendData.member,
					appId: this.sendData.appId,
					memberId: this.sendData.memberId, //会员卡id
					address: this.sendData.address
				}
				this.$http.post("member/saveOrUpdateDetail", JSON.stringify(a)).then(res => {
					if (res.body.code == 200) {
						this.$message.success("保存成功")
						this.$router.push("/appletSettings");
					} else {
						this.$message.error(res.body.msg);
					}
				})
			},
			getMemberCard() {
				this.$http.get("member/listMember").then(res => {
					this.memberCard = res.body.data
				})
			},
			addTypeMethod() {

			},
			handleSizeChange01(val) {
				this.filter.pageSize = val;
				this.getCoupon();
			},
			handleCurrentChange01(val) {
				this.filter.pageNum = val;
				this.getCoupon();
			},
			handleSizeChange02(val) {
				this.filter2.pageSize = val;
				this.getCouponPackage();
			},
			handleCurrentChange02(val) {
				this.filter2.pageNum = val;
				this.getCouponPackage();
			}
		}
	}
</script>

<style>
	.father {
		display: flex;
	}

	.left {
		/* background-color: #0000CC; */
		width: 50%;
	}

	.right {
		/* background-color: #008200; */
		width: 50%;
		height: auto;
		float: right;
	}
</style>